// components/OrderCard.js
import React from "react";
import "../css/OrdersScreen.css";
import { FaArrowRight } from "react-icons/fa";
import TopRightArrowIcon from "../assets/Icons/TopRightArrowIcon";

const OrderCard = ({ productImage, name, weight, price, customer, orderTime, deliveryTime, onClick }) => {
  return (
    <div className="order-card">
      <div className="order-card-img">
        <img src={productImage} alt={name} />
      </div>
      <div className="order-card-details">
        <h4>{name}</h4>
        <p className="order-meta">{weight} , ₹{price}</p>
        <p className="order-customer">Customer: {customer}</p>
        <p className="order-time">Ordering Time: {orderTime}</p>
        <p className="order-time">Est Delivery Time: {deliveryTime}</p>
            <button className="order-card-see-more" onClick={onClick}>
                        <TopRightArrowIcon size={18} color="#000" className='TopRightArrowIcon'/>
                            See More...
                          </button>
      </div>
    </div>
  );
};

export default OrderCard;
